export enum TransferType {
    Car = 'car',
    Van = 'van',
    MiniBus = 'minibus',
    Bus = 'bus',
}
